import clsx from "clsx";
import React, { ReactNode } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Placement } from "react-bootstrap/esm/types";

type ConditionalTooltipProps = {
  tooltip: ReactNode;
  children: React.ReactElement;
  condition: boolean;
  className?: string;
  placement?: Placement;
  wide?: boolean;
};

const ConditionalTooltip = ({
  tooltip,
  children,
  condition,
  className,
  placement = "bottom",
  wide = false
}: ConditionalTooltipProps) =>
  condition ? (
    <OverlayTrigger
      overlay={
        <Tooltip
          style={{ zIndex: 99999 }}
          className={clsx(className, wide && "tooltip--wide")}
        >
          {tooltip}
        </Tooltip>
      }
      placement={placement}
    >
      {children}
    </OverlayTrigger>
  ) : (
    <>{children}</>
  );

export default ConditionalTooltip;
